export default __webpack_public_path__ + "static/media/scan-bunifikasi-picturemark-l.c37165a2.svg";